import React from 'react';
import { TableCell, TableRow, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { DynamicTableRowProps } from '@models/dynamic-table-row.model.ts';
import { useRowDoubleClick } from '@components/dynamic-table/components/dynamic-table-row/hooks/use-row-double-click.ts';
import {
  CLICKABLE_ROW_CLASS,
  ROW_HINT_DELAY_MS
} from '@utils/table-row.utils.ts';

const DynamicTableRow: React.FC<DynamicTableRowProps> = ({
  row,
  rowIndex,
  columns,
  tableKey,
  onRowDoubleClick
}) => {
  const { t } = useTranslation();
  const { isClickable, showHint, handleDoubleClick } = useRowDoubleClick({
    row,
    tableKey,
    onRowDoubleClick
  });
  const rowBg = rowIndex % 2 === 1 ? 'var(--gray-11)' : 'var(--white)';

  return (
    <Tooltip
      title={showHint ? t('tooltip_table_row_double_click') : ''}
      placement="top"
      enterDelay={ROW_HINT_DELAY_MS}
      enterNextDelay={ROW_HINT_DELAY_MS}
      describeChild
    >
      <TableRow
        className={isClickable ? CLICKABLE_ROW_CLASS : undefined}
        onDoubleClick={handleDoubleClick}
      >
        {columns.map((column, index) => {
          const isLast = index === columns.length - 1;

          return (
            <TableCell
              key={column.id}
              sx={
                isLast
                  ? {
                      position: 'sticky',
                      right: 0,
                      backgroundColor: rowBg,
                      zIndex: 1,
                      boxShadow: '-2px 0 5px var(--gray-alpha-40)'
                    }
                  : undefined
              }
            >
              <div className="clamp-text">
                {column.render(row[column.field], row)}
              </div>
            </TableCell>
          );
        })}
      </TableRow>
    </Tooltip>
  );
};

export default DynamicTableRow;
